import React from 'react';
import './Banner.css';
import productImage1 from './product1.png';
import productImage2 from './product2.png';
import productImage4 from './product4.png';

const Banner: React.FC = () => {
  return (
    <section className="banner">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6">
            <h1>Kubo TapTap</h1>
            <p className="banner-subtitle">Interactive "Find the Object" Adventure for Kids</p>
            <p className="banner-description">
              A vibrant world where children discover and learn new words through a fun, 
              interactive tapping game. Explore different themes and find hidden objects!
            </p>
            <ul className="features-list">
              <li>
                <span className="feature-icon">🌍</span>
                <div>
                  <strong>Diverse Exploration Worlds</strong>
                  <p>Discover a vast variety of themes from the Ocean to the Space and more.</p>
                </div>
              </li>
              <li>
                <span className="feature-icon">🗣️</span>
                <div>
                  <strong>Smart Voice Interaction</strong>
                  <p>Learn pronunciation in English and Vietnamese naturally.</p>
                </div>
              </li>
              <li>
                <span className="feature-icon">✨</span>
                <div>
                  <strong>Premium Experience</strong>
                  <p>Beautiful animations and glassmorphism design for modern kids.</p>
                </div>
              </li>
            </ul>
          </div>
          <div className="col-md-6">
            <div className="row">
              <div className="col-12 mb-4">
                <img src={productImage1} alt="Product 1" className="img-fluid rounded shadow-lg" />
              </div>
              <div className="col-12">
                <img src={productImage2} alt="Product 2" className="img-fluid rounded shadow-lg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
